module.exports = __webpack_public_path__ + "static/media/specialist.adb40cb1.svg";